module.exports = __webpack_public_path__ + "static/media/italy.da49746d.svg";